/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'imggallery': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<g _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#ECF3F6" width="40" height="40" rx="2"/><g _fill="#7CCEFB"><path pid="1" d="M23.294 20.074l2.291 3.525h-4.624l2.333-3.525zm-8.469 3.525l1.987-2.631 2.102 2.63h-4.089zM13.2 15.06c0-.487.404-.884.9-.884h11.8c.496 0 .9.397.9.884v7.654a.857.857 0 0 1-.108.398l-3.389-5.215-3.362 5.078-3.155-3.95-3.28 4.342a.868.868 0 0 1-.306-.653V15.06zM25.9 13H14.1c-1.158 0-2.1.924-2.1 2.06v7.655c0 1.137.942 2.06 2.1 2.06h5.754l.18.225.148-.224H25.9c1.158 0 2.101-.924 2.101-2.061V15.06C28 13.924 27.057 13 25.9 13z"/><path pid="2" d="M19.153 18.185a.99.99 0 0 0 1-.98.992.992 0 0 0-1-.983c-.552 0-1 .44-1 .982a.99.99 0 0 0 1 .981"/></g></g>'
  }
})
